<div class="wrapper ds-tooltip">
	<img *ngIf="isHand" class="image" [src]="'./assets/Hand (White).svg' | resolveAsset" alt="stop" />
	<div class="content">
		{{ description }}
	</div>
</div>
